import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft, MailQuestion } from "lucide-react";

export default function ForgotPassword() {
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center p-6 font-sans"
      style={{ background: "linear-gradient(135deg, #00264D 0%, #003366 55%, #002855 100%)" }}
      data-testid="forgot-password-page"
    >
      <div className="bg-white rounded-2xl shadow-2xl p-8 lg:p-10 w-full max-w-md">
        <div className="w-[52px] h-[52px] rounded-xl border border-[#008080]/30 bg-[#008080]/10 flex items-center justify-center">
          <MailQuestion size={26} className="text-[#008080]" />
        </div>
        <h1 className="mt-6 text-3xl font-bold text-[#1F2937]">Reset your password</h1>
        <p className="text-slate-500 mt-2 text-sm">
          Password resets for the DPDP GRC Workspace are handled by your organisation administrator.
          Contact your CX0 workspace admin to have your credentials reissued.
        </p>

        <Link
          to="/login"
          className="mt-8 w-full flex items-center justify-center gap-2 py-3.5 rounded-lg bg-[#003366] hover:bg-[#002855] text-white font-semibold shadow-lg shadow-[#003366]/25 hover:-translate-y-0.5 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#008080] focus:ring-offset-2"
          data-testid="back-to-login-link"
        >
          <ArrowLeft size={18} />
          Back to sign in
        </Link>

        <div className="mt-8 border-t border-slate-100 pt-6 flex items-center justify-center gap-2">
          <ShieldCheck size={20} className="text-[#008080]" />
          <span className="font-semibold text-sm text-[#1F2937]">Secure. Reliable. Built for DPDP.</span>
        </div>
      </div>
    </div>
  );
}
